<template>
  <div>
    <b-card header="Invoice is Required for Label!" v-if="requireInvoice">
      <b-card-body>
        <b-row>
          <b-col sm="6">
            <div class="mb-3">
              <b-form-file
                  placeholder="Choose a file or drop it here..."
                  drop-placeholder="Drop file here..."
                  multiple
                  v-model="files"
                  accept=".pdf"
                  @input="setFile($event)"
              ></b-form-file>
            </div>
          </b-col>
          <b-col sm="6">
            <div>
              <b-button size="sm" @click="showInvoice" >Create Invoice</b-button>
            </div>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import CreateInvoice from "@/views/CreateInvoice";
import validationSummary from '@/mixins/validationSummary';
import {ACTIONS, CREATE_SHIPMENT_PREFIX} from "@/store/constants";

export default {
  name: "BookRequireInvoice",
  components: {CreateInvoice},
  mixins: [validationSummary],
  props: {
    requireInvoice: {type: Boolean, required: true},
    v: {required: true}
  },
  data() {
    return {
      files: []
    }
  },
  methods:{
    setFile(event){
      if (event.length > 0)
      {
        if (event[0].name.toLowerCase().endsWith('.pdf')){
          this.$emit('setFiles',event)
        }
        else {
          this.files = []
        }
      }
      
    },
    showInvoice() {
      this.v.$touch();

      if (this.v.shipment.$anyError) {
        let validationErrors = this.$allErrors;

        this.$store.dispatch(
            CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.SET_BACKENDERROR,
            {
              localizedMessage: 'Please correct validation errors: ',
              validationErrors: validationErrors,
            }
        );

        return;
      }
      this.$emit('show',true)
    }
  },
  computed: {
    ...mapGetters('createShipment', [
      'isCustomsShipmentAndNotDocument'
    ])
  }
}
</script>

<style scoped>

</style>